
import { computed, defineComponent, ref, watch } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "ErrorPage",
  setup(props, { emit }) {
    const store = useStore();
    const displayModal = ref(false);
    let error: any = ref({});
    error = computed(() => store.getters["application/getError"]);
    watch(error, (currentValue, oldValue) => {
      displayModal.value = currentValue.title !== "";
    });
    const closeModal = () => {
      store.dispatch("application/clearError");
    };
    return { error, displayModal, closeModal };
  },
});
